import contacts from '../../../assets/icons/CONTACTOS_BLANCO.svg';
import personal from '../../../assets/icons/DATOS_PERSONALES_BLANCO.svg';
import groups from '../../../assets/icons/GRUPOS_BLANCO.svg';
import account from '../../../assets/icons/MI_CUENTA_BLANCO.svg';
import wishlist from '../../../assets/icons/VARITA_BLANCO.svg';

export enum EActiveMenuItem {
  WISHLIST = 'wishlist',
  GROUPLIST = 'group',
  MY_CONTACTS = 'myContacts',
  MY_BANK = 'myBank',
  PERSONAL_PAGE = 'personalPage'
}

export type TActiveMenuItem =
| EActiveMenuItem.WISHLIST
| EActiveMenuItem.GROUPLIST
| EActiveMenuItem.MY_CONTACTS
| EActiveMenuItem.MY_BANK
| EActiveMenuItem.PERSONAL_PAGE;

export const activeMenuItemKey = 'activeMenuItem';

export interface INavigationItems {
  img: string;
  path: string;
  title: string;
  [activeMenuItemKey]: TActiveMenuItem;
}


export const navigationItems: INavigationItems[] = [
  {
    img: wishlist,
    path: '/wishlist',
    title: 'organisms.navigation_menu.wishlist',
    [activeMenuItemKey]: EActiveMenuItem.WISHLIST
  },
  {
    img: groups,
    path: '/group',
    title: 'organisms.navigation_menu.groups',
    [activeMenuItemKey]: EActiveMenuItem.GROUPLIST
  },
  {
    img: contacts,
    path: '/my-contacts',
    title: 'organisms.navigation_menu.contacts',
    [activeMenuItemKey]: EActiveMenuItem.MY_CONTACTS
  },
  {
    img: account,
    path: '/my-bank',
    title: 'organisms.navigation_menu.my-bank',
    [activeMenuItemKey]: EActiveMenuItem.MY_BANK
  },
  {
    img: personal,
    path: '/personal-page',
    title: 'organisms.navigation_menu.personal',
    [activeMenuItemKey]: EActiveMenuItem.PERSONAL_PAGE
  },
];
